// extracted by css-extract-rspack-plugin
export default {"joinColumnPicker":"iE3mc"};